import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { formatPhone } from './formatPhone';

interface IProps {
    phone: string,
    onClick: () => void,
    onClose: () => void,
}

/**
 * Попап с ошибкой регистрации платежа СберПэй
 */
export const SberPayErrorPopup = ({
    phone,
    onClick,
    onClose,
}: IProps) => {
    return (
        <DefaultPopup isOpen={true} onClose={onClose}>
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <TextWrapper>
                    <H3 style={{ marginRight: 45 }}>Sber Pay</H3>
                    <Paragraph4 $color={COLORS.TextInfo}>
                        Не&nbsp;смогли отправить вам пуш-уведомление на&nbsp;оплату<br/> по&nbsp;номеру {formatPhone(phone)}
                    </Paragraph4>
                </TextWrapper>

                <ButtonGroup>
                    <Button bType={'action'} onClick={onClick}>Отправить еще раз</Button>
                    <Button bType={'secondary'} onClick={onClose}>Закрыть</Button>
                </ButtonGroup>
            </IndentContainer>
        </DefaultPopup>
    );
};
